module.exports = __webpack_public_path__ + "static/media/photo294.507cddf1.jpg";